import React from 'react';
import { cn } from '../../lib/utils';

export function Spinner({ className }) {
  return (
    <div
      className={cn(
        'h-6 w-6 animate-spin rounded-full border-2 border-white/15 border-t-white',
        className
      )}
    />
  );
}

export function FullPageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-base">
      <Spinner className="h-8 w-8" />
    </div>
  );
}
